import { Injectable } from '@angular/core';
declare let rudderanalytics: any;

@Injectable()
export class GoogleAnalytics {
  public emitEvent(eventCategory: string, eventAction: string, eventLabel: string = null, eventValue: number = null) {
    rudderanalytics.track('Payments', {
      event_category: eventCategory,
      event_action: eventAction,
      event_label: eventLabel
    });
  }
}